import { types } from 'mobx-state-tree';

export const type = types.optional(types.model({

}), {});

export const node = type.create({
});